import { Badge } from '@/components/ui/Badge';

/**
 * Marks a write that reached the server after the run was sealed — authored
 * offline while the run was active, uploaded once someone else had sealed it.
 * The neighbouring stamp shows when it was written; this says the sealed record
 * didn't know about it at seal time.
 */
export function AfterSealBadge() {
  return <Badge label="after seal" tone="outline" />;
}
